var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.938 7c-2.153 0-2.424.01-3.27.048a5.85 5.85 0 0 0-1.929.369c-.53.2-1.01.512-1.406.916a3.898 3.898 0 0 0-.916 1.406 5.815 5.815 0 0 0-.37 1.925c-.037.85-.047 1.12-.047 3.274s.01 2.425.048 3.271c.013.66.138 1.31.369 1.928a4.062 4.062 0 0 0 2.321 2.325 5.828 5.828 0 0 0 1.928.37c.847.037 1.117.047 3.274.047s2.426-.01 3.273-.047a5.86 5.86 0 0 0 1.928-.37 4.063 4.063 0 0 0 2.322-2.322c.23-.617.355-1.269.369-1.928.037-.846.047-1.116.047-3.273 0-2.156-.01-2.426-.047-3.274a5.869 5.869 0 0 0-.37-1.926c-.2-.53-.512-1.01-.916-1.407a3.882 3.882 0 0 0-1.406-.915 5.84 5.84 0 0 0-1.928-.37C17.364 7.01 17.095 7 14.938 7Zm-.71 1.431h.71c2.12 0 2.37.007 3.207.046a4.4 4.4 0 0 1 1.48.273c.345.127.657.33.913.594.264.256.467.568.594.914.175.471.268.97.273 1.473.039.837.047 1.088.047 3.207 0 2.12-.008 2.371-.047 3.208a4.392 4.392 0 0 1-.273 1.473 2.631 2.631 0 0 1-1.51 1.506 4.37 4.37 0 0 1-1.474.274c-.837.037-1.087.047-3.207.047s-2.375-.01-3.21-.047a4.39 4.39 0 0 1-1.473-.274 2.46 2.46 0 0 1-.913-.594 2.46 2.46 0 0 1-.595-.913 4.386 4.386 0 0 1-.273-1.474c-.04-.836-.046-1.088-.046-3.206 0-2.12.007-2.376.046-3.21a4.393 4.393 0 0 1 .273-1.474c.127-.345.33-.657.594-.913.257-.263.57-.465.914-.591.472-.175.97-.268 1.474-.274.732-.034 1.016-.044 2.496-.044Zm4.95 1.319a.953.953 0 1 0 .001 1.905.953.953 0 0 0 0-1.905Zm-4.24 1.113a4.077 4.077 0 1 0 .007 8.154 4.077 4.077 0 0 0-.008-8.154Zm0 1.43a2.647 2.647 0 1 1 .006 5.293 2.647 2.647 0 0 1-.007-5.293Z",
    fill: "#ECECEC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -29.7322 27.6533 0 7.969 32.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(78.681 -3.83 -1.985) scale(13.2904 54.7837)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5b55c6a491b4c2b94da9266bbf630ee2.svg";
export { ForwardRef as ReactComponent };